import { PublicationListOrderingKey } from "@/components/business/PublicationListContainer/publicationList.types";
import { usePublicationListFilterState } from "@stores/publicationList";

import {
  ORDERING_TABLE,
  Ordering,
  TABLE_HEADER_LIST,
  TableHeaderList,
} from "../../../constants/publicationListTable.constants";

interface UseHandlePublicationListTableOrderingReturn {
  tableHeaderList: TableHeaderList[];
  handleOrdering: (
    orderingTitle: PublicationListOrderingKey,
    ordering: Ordering,
  ) => void;
  getOrderingIcon: (ordering: Ordering) => string;
  checkIsOrdering: (ordering: Ordering) => boolean;
}

export const useHandlePublicationListTableOrdering =
  (): UseHandlePublicationListTableOrderingReturn => {
    const [publicationListFilter, setPublicationListFilter] =
      usePublicationListFilterState();
    const { order } = publicationListFilter;

    const tableHeaderList: TableHeaderList[] = TABLE_HEADER_LIST.map(
      (tableHeader: TableHeaderList) => {
        const orderingValue = order[tableHeader.orderingTitle] || "none";
        return {
          ...tableHeader,
          ordering: orderingValue,
        };
      },
    );

    const handleOrdering = (
      orderingTitle: PublicationListOrderingKey,
      ordering: Ordering,
    ) => {
      const updatedOrdering = ORDERING_TABLE[ordering];
      let updatedOrderObject = { ...order };

      if (orderingTitle in order) {
        delete updatedOrderObject[orderingTitle];
      }

      updatedOrderObject = {
        ...updatedOrderObject,
        [orderingTitle]: updatedOrdering,
      };

      if (updatedOrdering === "none") {
        delete updatedOrderObject[orderingTitle];
      }
      setPublicationListFilter({
        ...publicationListFilter,
        order: updatedOrderObject,
      });
    };

    const getOrderingIcon = (ordering: Ordering) => {
      if (ordering === "asc") return "▲";
      if (ordering === "desc") return "▼";
      return "";
    };

    const checkIsOrdering = (ordering: Ordering) => {
      if (ordering === "none") return false;
      return true;
    };

    return {
      tableHeaderList,
      handleOrdering,
      getOrderingIcon,
      checkIsOrdering,
    };
  };
